import React, { useState } from "react";
import { useParams } from "react-router-dom";
//import { Identity } from "../../../components/Identity";
import { PageTopbar } from "../../../components/Page/Topbar";
import { PageHeader } from "../../../components/Page/Header";
import { AppManagementInvoices } from "../../../app/Management/Invoices";
import { getPageTitle } from "../../../app/helpers/global";

export function RoutesRentalsCasesInvoices({ parents, current }) {

    let identifier = (parents + current).replaceAll('/', '-');
    let group = (parents).replaceAll('/', '-');

    const { rentalCaseId } = useParams();
    const [title, setTitle] = useState(null);
    const [filterFields, setFilterFields] = useState([]);
    const [filterValues, setFilterValues] = useState(JSON.parse(localStorage.getItem("filters" + identifier)) ?? {});
    const [refresh, setRefresh] = useState(false);


    if (title === null) {
        getPageTitle('rental', rentalCaseId, setTitle);
    }

    const resetFilterValues = (values) => {
        setFilterValues(values);
        setRefresh(refresh === false);
    }

    return (
        <div>
            <PageTopbar
                parents={parents}
                current={current}
            />

            {/* <Identity /> */}

            <PageHeader
                title={title}
                parents={parents}
                current={current}
                variables={{ rentalCaseId: rentalCaseId }}
                tabGroup={group}
                filterFields={filterFields}
                setFilterValues={resetFilterValues}
                identifier={identifier}
            />

            <AppManagementInvoices
                current={current}
                filterValues={filterValues}
                setFilterFields={setFilterFields}
                identifier={identifier}
                viewType="rental-case"
                typeId={rentalCaseId}
            />
        </div>
    );
}